import { useState, useEffect } from "react";


function RSVPHistory({ currentResponseID, setCurrentResponseID }) {
    const [currentResponseHistory, setCurrentResponseHistory] = useState(null)
    const [pageLoading, setPageLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(false);

    useEffect(() => {
        fetchHistory();
    }, []);

    async function fetchHistory() {
        if (currentResponseID) {
            try {
                const res = await fetch(
                    `https://wedding-website-backend-nu.vercel.app/api/responses/${currentResponseID}`
                );

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status}`);
                }

                const data = await res.json();
                setCurrentResponseHistory(data.history);
            } catch (err) {
                console.error(err);
                setLoadingError(true);
            } finally {
                setPageLoading(false);
            }
        }
    }


    function renderVersion(change, nextVersion = null) {
        const date = new Date(change.created_at);
        const options = {
            timeZone: "America/New_York",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
        };
        const estDateStr = date.toLocaleString("en-US", options);

        // Helper to highlight changes compared to NEXT version
        const diff = (field, fieldName) => {
            if (!nextVersion) return String(field); // last/original version
            if (field !== nextVersion[fieldName]) {
                return <span className="text-red-400">{String(field)}</span>;
            }
            return String(field);
        };

        // Guests comparison
        const renderGuest = (guest, index) => {
            const nextGuest = nextVersion?.guests?.[index] || {};
            const diffGuest = (field, name) => {
                if (nextGuest[name] !== undefined && nextGuest[name] !== guest[name]) {
                    return <span className="text-red-400">{String(guest[name])}</span>;
                }
                return String(guest[name]);
            };

            return (
                <li key={guest.name} className="p-2">
                    <div>{diffGuest(guest.name, "name")}</div>
                    <div className="text-sm">
                        <div>
                            Attending Welcome Party:{" "}
                            {diffGuest(guest.attend_welcome_party, "attend_welcome_party")}
                        </div>
                        <div>
                            Attending Wedding:{" "}
                            {diffGuest(guest.attend_wedding, "attend_wedding")}
                        </div>
                        <div>Wedding Entree: {diffGuest(guest.wedding_entree, "wedding_entree")}</div>
                        <div>Dietary Restrictions: {diffGuest(guest.dietary_restrictions, "dietary_restrictions")}</div>
                    </div>
                </li>
            );
        };

        return (
            <div key={change._id} className="bg-blush p-2">
                <div className="text-xs mb-2">{estDateStr}</div>
                <div className="text-xs mb-2">IP Address: {diff(change.ip_address, "ip_address")}</div>
                <div>Email: {diff(change.email, "email")}</div>
                <div>Phone: {diff(change.phone, "phone")}</div>
                <div>Comments: {diff(change.comments, "comments")}</div>
                <ul className="space-y-1">{change.guests.map(renderGuest)}</ul>
            </div>
        );
    }

    return (
        <div className="p-2">
            {pageLoading && <p>Loading...</p>}
            {loadingError && <p className="text-red-400">Failed to fetch RSVP history</p>}
            {!pageLoading && !loadingError && (
                <>
                    <button
                        className="px-3 py-1 text-lg font-medium text-white bg-bronze hover:bg-gold hover:text-customGray"
                        onClick={() => {
                            setCurrentResponseID(null);
                            setCurrentResponseHistory(null);
                        }}
                    >
                        Back to all RVSPs
                    </button>
                    <div className="bg-white mt-4 p-2 border space-y-2">
                        {currentResponseHistory.map((change, index) => {
                            const next = index < currentResponseHistory.length - 1
                                ? currentResponseHistory[index + 1]
                                : null;
                            return renderVersion(change, next);
                        })}
                    </div>
                </>
            )}
        </div>
    )
}

export default RSVPHistory